import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Input,
  Select,
  Popconfirm,
  Space,
  Card,
  DatePicker,
} from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getSearchApiSearchText } from '../../../network/itemList';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getEmployeeAdvanceInfo } from '../../../network/expenseClaimSubmit';

const AdvancesList = ({
  edit,
  amountAdvance,
  dataSourceTax,
  setDataSourceAdvances,
  dataSourceAdvances,
  t,
}) => {
  const [count, setCount] = useState(0);
  console.log(dataSourceAdvances, 'dataSourceAdvances');

  const [searchTextEmployee, setSearchTextEmployee] = useState('');
  const { data: employees } = useQuery({
    queryKey: [queryKeys.getEmployeeSearch, searchTextEmployee],
    queryFn: () =>
      getSearchApiSearchText({
        type: 'Employee Advance',
        searchTxt: searchTextEmployee,
      }),
    keepPreviousData: true,
  });
  // useEffect(() => {
  //   if(dataSourceTax?.length > 0){
  //     const totalAmount = dataSourceTax?.reduce((acc, item) => acc + Number(item?.total), 0);

  //   }
  // }, [dataSourceTax]);
  useEffect(() => {
    if (amountAdvance > 0 && !edit) {
      const totalAmount = amountAdvance;
      const checkRow = dataSourceAdvances?.find(
        (item) => item?.unclaimed_amount >= totalAmount
      );

      if (checkRow) {
        setDataSourceAdvances((prevData) =>
          prevData.map((item) =>
            item?.key === checkRow?.key
              ? { ...item, allocated_amount: totalAmount }
              : { ...item, allocated_amount: 0 }
          )
        );
      } else {
        setDataSourceAdvances((prevData) =>
          prevData.map((item) => ({
            ...item,
            allocated_amount: 0,
          }))
        );
      }
    }
  }, [amountAdvance]);

  const columns = [
    {
      title: t.employeeAdvance,
      dataIndex: 'employee_advance',
      render: (text, record, index) => (
        <Select
          placeholder={t.employeeAdvance}
          style={{ width: '100%' }}
          value={record.employee_advance}
          popupMatchSelectWidth={false}
          allowClear
          showSearch
          disabled
          filterOption={false}
          onSearch={(value) => {
            setSearchTextEmployee(value);
          }}
          onChange={(value) => {
            const newDataSource = [...dataSourceAdvances];
            newDataSource[index] = {
              ...newDataSource[index],
              employee_advance: value,
            };
            setDataSourceAdvances(newDataSource);
          }}
          options={employees?.message?.map((item) => ({
            value: item?.value,
            label: item?.value,
          }))}
        />
      ),
    },
    {
      title: t.postingDate,
      dataIndex: 'posting_date',
      render: (text, record, index) => (
        <DatePicker
          placeholder={t.postingDate}
          format="YYYY-MM-DD"
          style={{ width: '100%' }}
          disabled
          value={dayjs(record.posting_date)}
          onChange={(date) => {
            const newDataSource = [...dataSourceAdvances];
            newDataSource[index] = {
              ...newDataSource[index],
              posting_date: date ? date.format('YYYY-MM-DD') : null,
            };
            setDataSourceAdvances(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.advancePaid,
      dataIndex: 'advance_paid',
      render: (text, record, index) => (
        <Input
          placeholder={t.advancePaid}
          style={{ width: '100%' }}
          value={record.advance_paid}
          type="number"
          min={0}
          disabled
          onChange={(e) => {
            const newDataSource = [...dataSourceAdvances];
            newDataSource[index] = {
              ...newDataSource[index],
              advance_paid: e.target.value,
            };
            setDataSourceAdvances(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.unclaimedAmount,
      dataIndex: 'unclaimed_amount',
      render: (text, record, index) => (
        <Input
          placeholder={t.unclaimedAmount}
          style={{ width: '100%' }}
          value={record.unclaimed_amount}
          type="number"
          min={0}
          disabled
          onChange={(e) => {
            const newDataSource = [...dataSourceAdvances];
            newDataSource[index] = {
              ...newDataSource[index],
              unclaimed_amount: e.target.value,
            };
            setDataSourceAdvances(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.allocatedAmount,
      dataIndex: 'allocated_amount',
      render: (text, record, index) => (
        <Input
          placeholder={t.allocatedAmount}
          style={{ width: '100%' }}
          value={record.allocated_amount}
          type="number"
          min={0}
          max={record.unclaimed_amount}
          onChange={(e) => {
            const newDataSource = [...dataSourceAdvances];
            newDataSource[index] = {
              ...newDataSource[index],
              allocated_amount: e.target.value,
            };
            setDataSourceAdvances(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
      employee_advance: '',
      posting_date: null,
      advance_paid: 0,
      unclaimed_amount: 0,
      allocated_amount: 0,
      advance_account: '',
    };
    setDataSourceAdvances((prevDataSource) => [...prevDataSource, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSourceAdvances.filter((item) => item.key !== key);
    setDataSourceAdvances(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSourceAdvances}
        columns={columns}
        pagination={{ hideOnSinglePage: true }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      {/* <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button> */}
    </Card>
  );
};

export default AdvancesList;
